module.exports = __webpack_public_path__ + "img/link_icon.666a27e0.svg";